/* eslint-disable camelcase */
import {
  DescriptionOutlined,
  ReceiptLongOutlined,
  NotificationsActiveOutlined,
  EventRepeatOutlined,
  VolunteerActivismOutlined,
  MarkEmailReadOutlined,
} from '@mui/icons-material';
import { Box, Grid, SvgIconProps, Typography } from '@mui/material';
import { ComponentType, useEffect, useState } from 'react';
import { useFormContext } from 'react-hook-form';
import { SendingOrderProduct } from 'src/modules/sending/models/sendingOrderProduct';
import GridWrapper from 'src/shared/components/organisms/gridWrapper';
import { SelectableCard } from 'src/shared/components/form/selectableCard';
import ConsoleHelper from 'src/shared/functions/consoleHelper';
import { useIsMounted } from 'src/shared/hooks/useIsMounted';
import { getAllSendingOrderProduct } from 'src/shared/services/sendingService';

// Väljer ikon utifrån nyckelord i produktnamnet (typ-fält saknas i snd_orderProduct). Dokumentikon som fallback.
const getProductIcon = (name: string): ComponentType<SvgIconProps> => {
  const n = (name || '').toLowerCase();
  if (n.includes('påminn') || n.includes('krav') || n.includes('inkasso')) return NotificationsActiveOutlined;
  if (n.includes('årsavgift') || n.includes('förnya') || n.includes('förnyelse') || n.includes('avgift')) return EventRepeatOutlined;
  if (n.includes('gåva') || n.includes('donation') || n.includes('insaml')) return VolunteerActivismOutlined;
  if (n.includes('välkomst') || n.includes('nyhets') || n.includes('brev')) return MarkEmailReadOutlined;
  if (n.includes('faktura') || n.includes('avi') || n.includes('medlem')) return ReceiptLongOutlined;
  return DescriptionOutlined;
};

export const SendingWizardStep2Type = () => {
  const isMounted = useIsMounted();
  const { setValue, watch } = useFormContext();
  const [products, setProducts] = useState<SendingOrderProduct[]>([]);

  const selectedProductId = watch('product_id') as number | undefined;

  useEffect(() => {
    const fetchProducts = async () => {
      try {
        const result = await getAllSendingOrderProduct();
        if (isMounted()) {
          // Påminnelser beställs inte som en egen utskickstyp längre – de är led på aviseringsbeställningen
          // och väljs i samma steg när huvudutskicket är inskickat. Filtrera bort dem här så det bara finns en väg.
          setProducts(result.data.filter((product) => !(product.name ?? '').toLowerCase().includes('påminnel')));
        }
      } catch (e) {
        if (isMounted()) {
          ConsoleHelper.log(e);
        }
      }
    };
    fetchProducts();
  }, [isMounted]);

  return (
    // Smalare, centrerat innehåll för typ-steget så korten inte blir orimligt breda i modalen.
    <Box sx={{ maxWidth: 820, mx: 'auto' }}>
      <GridWrapper>
        <Grid item xs={12}>
          <Typography variant='h5' sx={{ fontWeight: 700, mb: 2 }}>
            Vilken typ av fakturautskick vill ni göra?
          </Typography>
        </Grid>
        <Grid item xs={12}>
          <Grid container spacing={2}>
            {products.map((product) => {
              const Icon = getProductIcon(product.name);
              return (
                <Grid item xs={12} md={4} key={product.id}>
                  <SelectableCard
                    selected={selectedProductId === product.id}
                    onClick={() => setValue('product_id', product.id, { shouldValidate: true })}
                    icon={<Icon />}
                    title={product.name}
                  />
                </Grid>
              );
            })}
          </Grid>
        </Grid>
      </GridWrapper>
    </Box>
  );
};
